// src/components/notifications/SnackbarBridge.tsx
//
// Mounts inside <SnackbarProvider> and registers notistack's enqueue/close
// functions with the module-level notifications API so non-React callers
// (axios interceptors, etc.) can fire toasts via the typed helpers.
//
// Render exactly one of these — typically as the first child of SnackbarProvider.

import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { registerNotifier, unregisterNotifier } from '../../utils/notifications';

export const SnackbarBridge = (): null => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    registerNotifier(enqueueSnackbar, closeSnackbar);
    return () => {
      unregisterNotifier();
    };
  }, [enqueueSnackbar, closeSnackbar]);

  return null;
};
